import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CheckCircle, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { mockData } from "../mock";

export const Services = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const handleWhatsAppContact = (serviceName) => {
    const message = encodeURIComponent(
      `Olá! Gostaria de saber mais sobre ${serviceName}.`
    );
    window.open(
      `https://wa.me/${mockData.company.whatsapp}?text=${message}`,
      "_blank"
    );
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-50 to-blue-50 py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nossos Serviços
          </h1>
          <p className="text-xl text-gray-600">
            Soluções completas em forros para todos os tipos de ambientes.
            Qualidade garantida e acabamento profissional.
          </p>
        </div>
      </section>

      {/* Services Detail */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto space-y-16">
          {mockData.services.map((service, index) => (
            <div
              key={service.id}
              id={service.slug}
              className="scroll-mt-24"
            >
              <Card className="overflow-hidden hover:shadow-xl transition-shadow">
                <div
                  className={`grid lg:grid-cols-2 gap-8 ${
                    index % 2 === 1 ? "lg:grid-flow-dense" : ""
                  }`}
                >
                  <div
                    className={`${
                      index % 2 === 1 ? "lg:col-start-2" : ""
                    }`}
                  >
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <CardContent className="p-8 flex flex-col justify-center">
                    <div className="inline-block px-4 py-1 bg-blue-100 text-blue-600 rounded-full text-sm font-medium mb-4 w-fit">
                      {service.title}
                    </div>
                    
                    <h2 className="text-3xl font-bold text-gray-900 mb-4">
                      {service.title}
                    </h2>
                    
                    <p className="text-lg text-gray-600 mb-6">
                      {service.fullDescription}
                    </p>

                    <div className="mb-6">
                      <h3 className="text-xl font-semibold text-gray-900 mb-3">
                        Benefícios:
                      </h3>
                      <ul className="space-y-2">
                        {service.benefits.map((benefit, i) => (
                          <li
                            key={i}
                            className="flex items-start space-x-2 text-gray-600"
                          >
                            <CheckCircle
                              size={20}
                              className="text-green-500 mt-0.5 flex-shrink-0"
                            />
                            <span>{benefit}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="mb-6">
                      <h3 className="text-xl font-semibold text-gray-900 mb-3">
                        Aplicações:
                      </h3>
                      <div className="flex flex-wrap gap-2">
                        {service.applications.map((app, i) => (
                          <span
                            key={i}
                            className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm"
                          >
                            {app}
                          </span>
                        ))}
                      </div>
                    </div>

                    <Button
                      onClick={() => handleWhatsAppContact(service.title)}
                      className="bg-blue-600 hover:bg-blue-700 w-full sm:w-auto"
                    >
                      Solicitar Orçamento
                      <ArrowRight size={18} className="ml-2" />
                    </Button>
                  </CardContent>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-blue-600 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Não Encontrou o Que Procura?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Também realizamos projetos personalizados sob medida. Entre em
            contato e vamos conversar sobre seu projeto!
          </p>
          <Button
            onClick={() => handleWhatsAppContact("projeto personalizado")}
            size="lg"
            className="bg-white text-blue-600 hover:bg-gray-100"
          >
            Falar com Especialista
            <ArrowRight className="ml-2" size={20} />
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Services;
